import React, { useMemo } from 'react';

import { removeNulls } from '@trqk/utils';

import { Chart } from './Chart';
import { ChartOrEmptyMessage } from '../..';
import { mapChartTracksToGenres } from '../../helpers';

interface Props {
    chartDivId: string;
    dashboard: ProIngestionDashboard;
    height: number;
    genre: BroadcastOrDigital;
    maxSize?: number;
    minValue?: number;
}

export const EarningsPerMusicUserGenreV2 = ({
    chartDivId,
    dashboard,
    height,
    genre,
    maxSize = 0,
    minValue = 0,
}: Props): JSX.Element => {
    const chartTracks = dashboard?.chart_tracks ?? null;
    const musicUserGenres = removeNulls(dashboard.music_user_genres);

    const mappedTracks = useMemo(() => {
        const { data } = mapChartTracksToGenres(
            chartTracks,
            genre,
            maxSize,
            minValue,
        );

        return data;
    }, [chartTracks]);

    return (
        <ChartOrEmptyMessage height={height} data={mappedTracks}>
            <Chart
                chartDivId={chartDivId}
                height={height}
                tracks={mappedTracks}
                musicUserGenres={musicUserGenres}
            />
        </ChartOrEmptyMessage>
    );
};
